import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation files
import jaTranslations from '../locales/ja';
import enTranslations from '../locales/en';

const resources = {
  ja: {
    translation: jaTranslations,
  },
  en: {
    translation: enTranslations,
  },
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    resources,
    fallbackLng: 'ja', // Default language is Japanese as per requirements
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    detection: {
      // navigator を order から除外することで、ブラウザの言語設定を無視
      // localStorage や cookie に設定がない場合は fallbackLng（日本語）を使用
      order: ['localStorage', 'cookie', 'querystring'],
      caches: ['localStorage', 'cookie'],
    },
  });

export default i18n;
